import { DialogActions, DialogContent, DialogTitle, Divider, Modal, ModalDialog } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';
import { Warning } from '@phosphor-icons/react';
import { t } from 'i18next';
import { isString } from 'lodash';
import { ReactNode } from 'react';

import { Button } from 'core/components';
import { IConfirmation, IConfirmationAction } from 'core/types';
import { renderHtmlMessage } from 'core/utils';
import { Color, Variant } from 'theme/enums';

interface IProps extends IConfirmation {
  isOpen: boolean;
  confirmationActions?: IConfirmationAction[];
  dialogSx?: SxProps;
  extraButtons?: ReactNode[];
}

export const Confirmation = ({
  isOpen,
  confirmBtnDisabled = false,
  color,
  variant = Variant.OUTLINED,
  title,
  icon = <Warning weight="fill" />,
  message,
  confirmBtnLabel = t('buttonLabelConfirm'),
  confirmBtnColor = Color.PRIMARY,
  cancelBtnColor = Color.NEUTRAL,
  cancelBtnLabel = t('buttonLabelCancel'),
  cancelBtnVariant = Variant.OUTLINED,
  onConfirm,
  onCancel,
  confirmationActions,
  dialogSx,
  extraButtons,
}: IProps) => {
  return (
    <Modal open={isOpen} onClose={onCancel}>
      <ModalDialog color={color} variant={variant} role="alertDialog" sx={dialogSx}>
        <DialogTitle>
          {icon}
          {title}
        </DialogTitle>
        <Divider />
        <DialogContent>{isString(message) ? renderHtmlMessage(message) : message}</DialogContent>
        <DialogActions sx={{ flex: 'none' }}>
          {onConfirm && (
            <Button
              text={confirmBtnLabel}
              variant={Variant.SOLID}
              color={confirmBtnColor}
              disabled={confirmBtnDisabled}
              onClick={onConfirm}
            />
          )}

          {confirmationActions &&
            confirmationActions.map((action, index) => (
              <Button
                key={index}
                text={action.label}
                variant={Variant.SOLID}
                color={confirmBtnColor}
                onClick={action.onClick}
              />
            ))}

          {extraButtons}

          <Button
            text={cancelBtnLabel}
            variant={cancelBtnVariant}
            color={cancelBtnColor}
            onClick={onCancel}
          />
        </DialogActions>
      </ModalDialog>
    </Modal>
  );
};
